import * as React from "react";
import { forwardRef } from "react";
const SvgIconUpload = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "m12.9 3.594-.471.451L7.84 8.633l.942.942 3.462-3.462v10.858h1.311V6.114l3.462 3.462.942-.942-4.588-4.59zM7 18.283v1.311h11.8v-1.311z", "data-name": "icon/upload", transform: "translate(-4.911 -3.594)", fill: "#57728a" }));
const ForwardRef = forwardRef(SvgIconUpload);
export { ForwardRef as ReactComponent };
